// constants

// action_component_subject
const APPEND_PLACE_BET_FINAL = "APPEND_PLACE_BET_FINAL";
const RESET_PLACE_BET_FINAL = "RESET_PLACE_BET_FINAL";
const SET_PLACE_BET_FINAL = "SET_PLACE_BET_FINAL";
const SET_PLACE_BET_FINAL2 = "SET_PLACE_BET_FINAL2";
const APPEND_PLACE_BET_FINAL2 = "APPEND_PLACE_BET_FINAL2";

// reducers

const initialState = [];

const Reducer = (state = initialState, action) => {
	switch (action.type) {
		case APPEND_PLACE_BET_FINAL:
			return [...state, { ...action.payload }];

		case APPEND_PLACE_BET_FINAL2:
			return [...state, ...action.payload];

		case RESET_PLACE_BET_FINAL:
			return [];

		case SET_PLACE_BET_FINAL:
			let tmp = [...state];
			if (action.payload > -1) {
				tmp.splice(action.payload, 1);
			}
			return [...tmp];

		case SET_PLACE_BET_FINAL2:
			return [...action.payload];

		default:
			return state;
	}
};

export default Reducer;

// actions

// action_component_subject, prefix set(not update),empty(not remove),hide,show
export const appendPlaceBetFinal = (payload) => {
	return {
		type: APPEND_PLACE_BET_FINAL,
		payload: payload,
	};
};

export const appendPlaceBetFinal2 = (payload) => {
	return {
		type: APPEND_PLACE_BET_FINAL2,
		payload: payload,
	};
};

export const resetPlaceBetFinal = () => {
	return {
		type: RESET_PLACE_BET_FINAL,
	};
};

export const setPlaceBetFinal = (index = -1) => {
	return {
		type: SET_PLACE_BET_FINAL,
		payload: index,
	};
};

export const setPlaceBetFinal2 = (payload) => {
	return {
		type: SET_PLACE_BET_FINAL2,
		payload: payload,
	};
};
